const defaultStore = {
  calloriesNorm: '',
  category: [],
  tabSelected: 0,
};

export default (state = defaultStore, action) => {
  switch (action.type) {
    case 'SET_CALLORIES_NORM':
      return {
        ...state,
        calloriesNorm: action.data,
      };

    case 'SET_EXCEPT_CATEGORIES':
      return {
        ...state,
        category: action.data,
      };

    case 'SET_DAY_TAB_SELECTED':
      return {
        ...state,
        tabSelected: action.data,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/setParams.js